exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Icons-4f0b60d5 .grid-4b6cd133{margin:0 -10px}.Icons-4f0b60d5 .grid-4b6cd133:before,.Icons-4f0b60d5 .grid-4b6cd133:after{display:table;content:'';clear:both}.GridItem-62bc4b41{height:150px;width:150px;margin:10px;display:block;float:left;text-align:center}.GridItem-62bc4b41 .icon-07737ed7{color:#686868}.GridItem-62bc4b41 p{margin:15px 0}\n", ""]);

// Exports
exports.locals = {
	"Icons": "Icons-4f0b60d5",
	"grid": "grid-4b6cd133",
	"GridItem": "GridItem-62bc4b41",
	"icon": "icon-07737ed7"
};